import React from "react";
import HeaderMenu from "./headerMenu";
import { headerStyle } from "./headerStyles";
import { withRouter } from "react-router-dom";
// import logo from "../../../../public/logo.png";

class HeaderContainer extends React.Component {
  render() {
    const { IsUserLoggedIn, onLogOut, history, isLoading } = this.props;
    return (
      <div style={headerStyle}>
        <div style={{ width: "100%", display: "inline-block" }}>
          <div style={{ float: "left", width: "50%" }}>
          <a href="https://invoicestacks.com/"><img src="/logo.png" alt="Logo" style={{ width: "33%" }} /></a> 
          </div>
          <div
            style={{ float: "right", width: "50%", textAlign: "center" }}
          >
  
          </div>
        </div>
        <div>
          <HeaderMenu
            IsUserLoggedIn={IsUserLoggedIn}
            onLogOut={onLogOut}
            history={history}
            isLoading={isLoading}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(HeaderContainer);
